// extracted by mini-css-extract-plugin
module.exports = {"time":"SummarySectionStyle_time__NgKwg","rootSummary":"SummarySectionStyle_rootSummary__JdPwH"};